import React from 'react';

import {format} from 'date-fns';
import {useGate, useUnit} from 'effector-react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

import {TaxpayerAccountGate, taxpayerDetailsModel} from '@entities/taxpayers/detail-model';
import {GridFieldConfig} from '@shared/types/grid';
import {mapTableColumns, Table} from '@shared/ui/Table2.0';

import {Statement, Statements} from '../styled';

import {formatAmount} from './helpers';

const config = (t: any): GridFieldConfig[] => [
    {id: 'date', header: t('page_taxpayer.balance.date'), width: 150},
    {id: 'accrued', header: t('page_taxpayer.balance.accrual'), minWidth: 220},
    {id: 'paid', header: t('page_taxpayer.balance.payed'), minWidth: 220},
    {id: 'debt', header: t('page_taxpayer.balance.debt'), minWidth: 220},
    {id: 'penalty', header: t('page_taxpayer.balance.penalty'), minWidth: 220},
];

export const AccountTab = () => {
    const {tin} = useParams<{tin: string}>();
    const {t} = useTranslation();
    const taxpayer = useUnit(taxpayerDetailsModel);
    const account = taxpayer.state.account;
    useGate(TaxpayerAccountGate, {tin});

    const data = (account?.dayTaxActivities ?? [])
        .filter((row: any) => row.accrued || row.paid || row.debt || row.penalty)
        .map((row: any) => ({
            date: row.date ? format(new Date(row.date), 'dd.MM.yyyy') : '—',
            accrued: formatAmount(row.accrued),
            paid: formatAmount(row.paid),
            debt: formatAmount(row.debt),
            penalty: formatAmount(row.penalty),
        }));

    return (
        <>
            <Statements>
                <Statement>
                    <span>{t('page_taxpayer.balance.start')}</span>
                    <strong>{formatAmount(account?.saldoStart)}</strong>
                </Statement>
                <Statement>
                    <span>{t('page_taxpayer.balance.end')}</span>
                    <strong>{formatAmount(account?.saldoEnd)}</strong>
                </Statement>
            </Statements>
            <Table
                columns={mapTableColumns(config(t))}
                data={data}
                isLoading={taxpayer.state.pending}
            />
        </>
    );
};
